import { QueryClient } from '@tanstack/react-query';

/**
 * 全局唯一的 QueryClient（默认值与原先写在 App.tsx 里的一致）。
 *
 * 抽成独立模块是为了让 authStore 在退出登录时能 clear()：App.tsx 已 import authStore，
 * 反向 import 会成环。管理后台在同一台机器上换管理员登录时，若不清缓存，
 * 新管理员首屏会先渲染上一位管理员拉取过的用户、客户、审核与支付数据。
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
